export interface SwaptionModelRecord {
  id: string;
  kind: 'HullWhiteLattice';
  hw_a: number;
  hw_sigma: number;
  rmse?: number;
  num_helpers?: number;
  grid_rows?: number;
  grid_cols?: number;
  grid_points?: number;
  as_of_date?: string;
  vol_surface_id?: string;
  discount_curve_id?: string;
  forwarding_curve_id?: string;
  swap_index_id?: string;
  createdAt: string;
  updatedAt: string;
}

const SWAPTION_MODELS_KEY = 'quantra_swaption_models';

function loadStored(): SwaptionModelRecord[] {
  try {
    const raw = localStorage.getItem(SWAPTION_MODELS_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function saveStored(models: SwaptionModelRecord[]): void {
  localStorage.setItem(SWAPTION_MODELS_KEY, JSON.stringify(models));
}

export function getSwaptionModels(): SwaptionModelRecord[] {
  return loadStored();
}

export function getSwaptionModelById(id: string): SwaptionModelRecord | null {
  return getSwaptionModels().find((m) => m.id === id) || null;
}

export function saveSwaptionModel(model: SwaptionModelRecord): void {
  const models = loadStored();
  const idx = models.findIndex((m) => m.id === model.id);
  const now = new Date().toISOString();
  const next: SwaptionModelRecord = {
    ...model,
    createdAt: idx >= 0 ? models[idx].createdAt : (model.createdAt || now),
    updatedAt: now,
  };
  if (idx >= 0) models[idx] = next;
  else models.push(next);
  saveStored(models);
}

export function deleteSwaptionModel(id: string): void {
  saveStored(loadStored().filter((m) => m.id !== id));
}

export function replaceSwaptionModels(models: SwaptionModelRecord[]): void {
  const now = new Date().toISOString();
  saveStored(
    models
      .filter((m) => m && typeof m.id === 'string' && m.id.trim().length > 0)
      .map((m) => ({
        ...m,
        createdAt: m.createdAt || now,
        updatedAt: m.updatedAt || now,
      }))
  );
}
